import { render, staticRenderFns } from "./mod2.vue?vue&type=template&id=35c027be&scoped=true&"
import script from "./mod2.vue?vue&type=script&lang=js&"
export * from "./mod2.vue?vue&type=script&lang=js&"
import style0 from "./mod2.vue?vue&type=style&index=0&id=35c027be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c027be",
  null
  
)

export default component.exports